import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalShell({ title, tagline, children, testId }) {
    return (
        <main className="max-w-3xl mx-auto px-4 py-8 sm:py-12" data-testid={testId}>
            <Link to="/" className="inline-flex items-center gap-1 text-sm font-bold hover:underline mb-4">
                <ArrowLeft className="w-4 h-4" /> Back
            </Link>
            <h1 className="display text-4xl sm:text-5xl font-black leading-[0.95] mb-2">{title}</h1>
            {tagline && <p className="text-sm text-[#4A4A4A] font-medium mb-6">{tagline}</p>}
            <div className="text-xs text-[#4A4A4A] font-medium mb-6">Last updated: {new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</div>
            <article className="bg-white brut-static rounded-xl p-6 sm:p-8 space-y-4 legal-copy">
                {children}
            </article>
            <div className="mt-6 rounded-lg brut-inset bg-[#FFE55C] p-4 text-xs font-medium">
                <strong>Not legal advice.</strong> This document is provided for transparency. It is not a substitute for advice from a licensed attorney in your jurisdiction.
            </div>
        </main>
    );
}
